import { render } from "./GridTabParteneri.vue?vue&type=template&id=c704130e&scoped=true&ts=true"
import script from "./GridTabParteneri.vue?vue&type=script&lang=ts"
export * from "./GridTabParteneri.vue?vue&type=script&lang=ts"

import "./GridTabParteneri.vue?vue&type=style&index=0&id=c704130e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c704130e"]])

export default __exports__